import { render, staticRenderFns } from "./ShareListHucha.vue?vue&type=template&id=fb963c9a"
import script from "./ShareListHucha.vue?vue&type=script&lang=js"
export * from "./ShareListHucha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports